import { BaseService } from './BaseService';
import { Enterprise, EnterpriseUser, EnterpriseLicenseUsage, EnterpriseReportType, EnterpriseExample } from '../models';

export class EnterpriseService extends BaseService {
  constructor() {
    super();
  }

  async getMyEnterprises() {
    const response = await this.get('/enterprises/my-enterprises');
    return (response.data.enterprises || []).map(e => new Enterprise(e));
  }


  async leaveEnterprise(enterpriseId) {
    await this.delete(`/enterprises/leave/${enterpriseId}`);
  }

  async redeemEnterpriseInvite(code) {
    const response = await this.post('/enterprises/invites/redeem', { code });
    return response.data;
  }
}

export default EnterpriseService;
